!(function () {
  "use strict";
  const abz_zoom_images = "div:not(.abz_color_inactive) > [data-zoom-image]";
  const t = "[data-zoom-caption]",
    e = "[data-zoom-image]",
    o = "[data-pswp-thumbs-template]",
    s = "[data-section-type]",
    i = ".pswp__thumbs",
    a = "product-images",
    n = "is-dragging",
    l = "variant--soldout",
    c = "variant--unavailable",
    r = "pswp-zoom-gallery",
    m = "pswp-zoom-gallery--single",
    h = "data-image-src",
    d = "data-image-width",
    p = "data-image-height";
  class u extends HTMLElement {
    constructor() {
      super(),
        (this.container = this.closest(s)),
        (this.images = this.querySelectorAll(e)),
        (this.zoomCaptions = this.container.querySelector(t)),
        (this.thumbsContainer = document.querySelector(i));
    }
    connectedCallback() {
      this.images.forEach((t, e) => {
        console.log(t)
        t.addEventListener("click", (o) => {
          o.preventDefault(),
            t.closest(a).classList.contains(n) ||
              (this.createZoom(e), (window.a11y.lastElement = t));
        }),
          t.addEventListener("keyup", (o) => {
            "Enter" === o.code &&
              (o.preventDefault(),
              this.createZoom(e),
              (window.a11y.lastElement = t));
          });
      });
    }
    createZoom(t) {
      this.images = this.querySelectorAll(abz_zoom_images); // custom code
      const abz_zoom_thumbs_template = this.container.querySelector(o);
      const filtered_thumbs = Array.from(abz_zoom_thumbs_template.content.children).filter(child => !child.classList.contains('abz_color_inactive'));
      const e = filtered_thumbs.map(thumb => thumb.outerHTML).join(''); 
      // const e = this.container.querySelector(o)?.innerHTML;

      
      let s = [],
        i = 0;
      this.images.forEach((o, t) => {
        const a = o.getAttribute(h);
        if (
          ((i += 1),
          s.push({
            src: a,
            w: parseInt(o.getAttribute(d)),
            h: parseInt(o.getAttribute(p)),
            msrc: a,
          }),
          this.images.length === i)
        ) {
          const o = {
            history: !1,
            focus: !1,
            index: t,
            mainClass: 1 === i ? `${r} ${m}` : `${r}`,
            showHideOpacity: !0,
            howAnimationDuration: 150,
            hideAnimationDuration: 250,
            closeOnScroll: !1,
            closeOnVerticalDrag: !1,
            captionEl: !0,
            closeEl: !0,
            closeElClasses: ["caption-close", "title"],
            tapToClose: !1,
            clickToCloseNonZoomable: !1,
            maxSpreadZoom: 2,
            loop: !0,
            spacing: 0,
            allowPanToNext: !0,
            pinchToClose: !1,
            addCaptionHTMLFn: (t, e, o) => {
              this.zoomCaption(t, e, o);
            },
            getThumbBoundsFn: () => {
              console.log(t)
              const e = this.images[t],
                o = window.scrollY || document.documentElement.scrollTop,
                s = e.getBoundingClientRect();
              return { x: s.left, y: s.top + o, w: s.width };
            },
          };
          new window.theme.LoadPhotoswipe(s, o),
            this.thumbsContainer &&
              "" !== e &&
              (this.thumbsContainer.innerHTML = e);
        }
      });
    }
    zoomCaption(t, e) {
      let o = "";
      const s = e.children[0];
      return (
        this.zoomCaptions &&
          ((o = this.zoomCaptions.innerHTML),
          this.zoomCaptions.closest(`.${l}`)
            ? s.classList.add(l)
            : s.classList.remove(l),
          this.zoomCaptions.closest(`.${c}`)
            ? s.classList.add(c)
            : s.classList.remove(c)),
        (s.innerHTML = o),
        !1
      );
    }
  }
  customElements.get("zoom-images") || customElements.define("zoom-images", u);
})();
